import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AppStoreService } from 'src/app/app-store.service';
import { IFeatureModel } from 'src/app/models/feature-model';

import { FeatureCommonService } from '../feature-common.service';

@Component({
  selector: 'app-manage-release-notes',
  host: { class: 'set-height' },
  template: `@if (initialized) {<manage-release-notes (featureErrorEvent)="handleError($event)" (feature403Event)="handle403($event)" (feature404Event)="handle404($event)"></manage-release-notes>}`,
  standalone: false
})
export class ManageReleaseNotesComponent implements OnInit {

  initialized = false;
  feature$: Observable<IFeatureModel>;

  constructor(
    private readonly appStoreService: AppStoreService,
    private readonly featureCommonService: FeatureCommonService,
  ) {}

  ngOnInit() {
    this.initialized = this.featureCommonService.initialize('manage-release-notes');
  }

  handleError(event){
    this.appStoreService.setFeatureError(event.detail);
  }

  handle403(event){
    this.appStoreService.setFeature403(event.detail);
  }

  handle404(event){
    this.appStoreService.setFeature404(event.detail);
  }

}
